import { ANALYTICS_TIMEFRAME } from '../Reports/types';

export const TIMEFRAME_FILTER_OPTIONS = Object.values(ANALYTICS_TIMEFRAME);

export const TIMEFRAME_COPY = {
  [ANALYTICS_TIMEFRAME.SEVEN_DAYS]: 'last7Days',
  [ANALYTICS_TIMEFRAME.OVERALL]: 'overall',
};
